<template>
	<div id="reportTab" class="page-navbar">
		<mt-navbar class="page-part" v-model="selected" id="tabHeader" :fixed="fixed">
	      <mt-tab-item id="1" v-show="tabShow['tab1']">服务报告</mt-tab-item>
	      <mt-tab-item id="2" v-show="tabShow['tab2']">专业报告</mt-tab-item>
	      <mt-tab-item id="3" v-show="tabShow['tab3']">日报</mt-tab-item>
	      <mt-tab-item id="4" v-show="tabShow['tab4']">资产报告</mt-tab-item>
	      <mt-tab-item id="5" v-show="tabShow['tab5']">巡检报告</mt-tab-item>
	    </mt-navbar>
	    <form class="search-area" action="" onsubmit="return false;">
			<mt-search v-model="searchParam" @keyup.native.enter="search" placeholder='请输入报告标题进行搜索'></mt-search>
		</form>
		<div id="reportContent" style="overflow: auto;">
			<mt-tab-container v-model="selected">
			<mt-tab-container-item :id="''+n" v-for="n in 5">
				<mt-loadmore :bottom-method="loadBottom" :top-method="loadTop"  :auto-fill="autoFill" :bottom-all-loaded="allLoadedParams['allLoaded'+n]" :ref="'loadmore'+n" bottomPullText="上拉加载更多" topLoadingText="加载中.." bottomDropText="释放加载">
						<div class="oneList" v-for="(item,index) in data[n-1]">
							<div class="listCont">
								<div>
									<div style="width:130px">报告名称：</div><div class="rightCol" @click="downloadReport(item,n)"><span style="text-decoration: underline;color: #1771b5;">{{item.reportName}}</span></div>
								</div>
								<div>
									<div style="width:130px">发布时间：</div><div class="rightCol">{{item.uploadDateStr}}</div>
								</div>	
							</div>
						</div>
				</mt-loadmore>
			</mt-tab-container-item>
			</mt-tab-container>
		</div>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	import apiConfig from '@/service/url'
	export default{
		name:'WcReportNavbar',
		data(){
			return{
				fixed:true,
				selected: "1",
				searchParam:'',
				autoFill:false,
				allLoadedParams:{
					allLoaded1:false,
					allLoaded2:false,
					allLoaded3:false,
					allLoaded4:false,
					allLoaded5:false
				},
				tabShow:{
					tab1:true,
					tab2:true,
					tab3:true,
					tab4:true,
					tab5:true
				},
				startSize:[0,0,0,0,0],
				pageCount:50,
				reportTypeList:['1','3','4','0','2'],
				data:[[],[],[],[],[]],
				reportIds:this.$route.query.reportIds,
				selectedFlag:true,
			}
		},
		methods:{
			calculateHeight(){
				//获取workPage的高度，不包括底部导航栏
				var reportPageH = document.getElementById("reportPage").clientHeight;
				//获取tabHeader的高度
				var tabH = document.getElementById("tabHeader").clientHeight;
				//tab的内容区的高度为
				var tabCont = document.getElementById("reportContent");
				tabCont.style.height = reportPageH-tabH-100+"px";
			},
			loadBottom(){
				//加载更多数据
				this.startSize[this.selected-1]+=this.pageCount;
				//在这个方法的最后需要手动调用loadmore的onTopLoaded事件。这是因为在加载数据后需要对组件进行一些重新定位的操作。
				this.getReportList(this.selected,(flag)=>{
					this.allLoadedParams['allLoaded'+this.selected] = true;
					this.$refs['loadmore'+this.selected][0].onBottomLoaded();
					if(flag){
						setTimeout(()=>{
							this.allLoadedParams['allLoaded'+this.selected] = false;
						},2000)
					}
				})
			},
			loadTop(){
				//加载更多数据
				this.startSize[this.selected-1]=0;
				//在这个方法的最后需要手动调用loadmore的onTopLoaded事件。这是因为在加载数据后需要对组件进行一些重新定位的操作。
				this.getReportList(this.selected,(flag)=>{
					this.$refs['loadmore'+this.selected][0].onTopLoaded();
				},true)
			},
			search(){
				this.startSize[this.selected-1]=0;
				this.getReportList(this.selected,()=>{},true)
			},
			getCurSelected(){
				setTimeout(()=>{
					let reportType = this.$route.query.reportType;
					let path = this.$route.path;
					if(reportType && path=="/report"){
						for(var i=0; i<this.reportTypeList.length; i++){
							let ind = i+1;
							if(this.reportTypeList[i]==reportType){
								this.selected=ind + "";
								this.tabShow['tab'+ind] = true;
							}else{
								this.tabShow['tab'+ind] = false;
							}
						}
					}
					this.getReportList(this.selected);
				},10);
			},
			downloadReport(item,index){
				let data={mark:"getValidInfo"};
				_api('_report','.code',{params:data},res=>{
					let openId = "";
					let unionId = "";
					if(res.data){
						openId = res.data.openId;
						unionId = res.data.unionId;
					}
					if(openId){
						openId = encodeURIComponent(openId);
					}
					if(unionId){
						unionId = encodeURIComponent(unionId);
					}
					let downloadUrl = apiConfig.baseURL + apiConfig.reportUrl + "&mark=downloadReport&reportId="+item.id 
									+ "&openId=" + openId + "&unionId=" + unionId;
					window.location.href=downloadUrl;
				},err=>{
					
				})
			},
			//获取当前选项的所有报告
			getReportList(index,sc,rebuild){
				let searchStr = this.searchParam.trim();
				if(searchStr){
					searchStr = encodeURIComponent(searchStr);
				}
				let data={mark:"reportList",startSize:this.startSize[index-1],pageCount:this.pageCount,reportType:this.reportTypeList[index-1],reportIds:this.reportIds,searchParam:searchStr};
				_api('_report','.code',{params:data},res=>{
					if(rebuild){
						this.data[index-1].splice(0,this.data[index-1].length)
					}
					if(res.data){
						res.data.forEach(item=>{
							this.data[index-1].push({
								id:item.id,
								reportName:item.reportName,
								uploadDateStr:item.uploadDateStr,
								reportType:item.type
							})
						})
						sc&&sc(true);
					}else{
						sc&&sc(false);
					}
					this.selectedFlag=!1;
				},err=>{
					
				})
			}
			
		},
		mounted() {
			this.$nextTick(()=>{
				this.calculateHeight();
			})
			
			this.getCurSelected();
			
		},
		watch:{
			selected(){
				if(!this.selectedFlag){
					this.searchParam='';
					this.startSize[this.selected-1]=0;
					this.getReportList(this.selected,()=>{},true)
				}
			}
		}
	}
</script>

<style>
	#reportTab .mint-navbar.is-fixed{
		top:45px;
		z-index: 11;
	}
	#reportContent{
		margin-top: 90px;
		-webkit-overflow-scrolling: touch;
	}
	#reportPage .oneList{
		width: 100%; 
		height: 80px;
		margin-top: 20px;
		background: #FFFFFF;
		border-bottom: 1px solid #DCDCDC;
		box-shadow: 2px 2px 10px #DDDDDD;
	}
	.search-area{
		height: 50px;
	    z-index: 12;
	    position: fixed;
	    width: 100%;
	    top: 85px;
	    background: #f3f3f3;
	}
	#reportPage .listTit{
		width: 130px;
	    height: 35px;
	    background: #029DCD;
	    position: relative;
	    top: -10px;
	    z-index: 9;
	    border-bottom-right-radius: 30px;
	    border-top-right-radius: 30px;
	    color: #FFFFFF;
	    font-size: 16px;
	    line-height: 35px;
	    padding-left: 15px;
		padding-right: 15px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	#reportPage .listCont{
		width: 100%;
	    height: 90px;
	    background: #FFFFFF;
	    position: relative;
	    top: -8px; 
	}
	#reportPage .listCont>div{
		padding: 5px 15px;
		display: flex;
		justify-content: space-between;
		color: #7F7F7F;
		font-size: 14px;
	}
	#reportPage .rightCol{
		color: #484848;
		word-wrap: break-word;
		word-break:break-all
	}
	#reportPage .titCol1{
		background:#029DCD;
	}
	#reportPage .titCol2{
		background:#02AEC4;
	}
	#reportPage .titCol3{
		background:#00C8BD;
	}
	#reportTab .mint-search{
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/report/reportTab/WcReportNavbar.vue